import React, { useState } from "react";

import { FrontendTempFilePasswordManagement } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { Card, IconButton } from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material"; // 👈 NEW icons
import { formatCustomDate } from "node-library/dist/helpers/date_helper";

interface Props {
	filePassword: FrontendTempFilePasswordManagement;
	goToViewFileDetails: () => void;
	// discardUnstartedOrder: () => void;
}

export default function FilePasswordCell(props: Props) {
	const { t: translation } = useTranslation();

	const [showPassword, setShowPassword] = useState<boolean>(false);
	const {
		goToViewFileDetails,
		filePassword,
		// discardUnstartedOrder,
	} = props;

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const fileHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			{/* <div
				className="typography-caption sample-status-box"
				style={{
					backgroundColor: statusColor.backgroundColor,
					border: `1px solid ${statusColor.borderColor}`,
					color: statusColor.textColor,
				}}
			>
				{statusString}
			</div> */}

			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const fileBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Name")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{filePassword.name}
				</div>
			</div>
			<div
				className="order-cell-body-row typography-body-02"
				style={{ alignItems: "center" }}
			>
				<div className="sample-info-row-description">
					{translation("Password")}
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "5px",
						maxWidth: "50%",
					}}
				>
					<div className="overflow-ellipsis-text">
						{showPassword ? filePassword.password : "••••••••"}
					</div>

					<IconButton
						size="small"
						onClick={(e) => {
							e.stopPropagation(); // 👈 prevent triggering goToViewFileDetails
							setShowPassword((prev) => !prev);
						}}
					>
						{showPassword ? <VisibilityOff /> : <Visibility />}
					</IconButton>
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Createdon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(filePassword.inserted as Date)}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Lastupdatedon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(filePassword.lastUpdated as Date)}
				</div>
			</div>
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={filePassword.id}
			onClick={() => {
				goToViewFileDetails();
			}}
		>
			{fileHeaderRow}
			{fileBody}
		</Card>
	);
}
